// extracted by mini-css-extract-plugin
module.exports = {"icon":"booking_date_icon__o5oqk","container":"booking_date_container__10aac","label":"booking_date_label__3mKZp"};